module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_comment_02@2x-cfdbb746acb37198fcd043d0c226fc1c.webp";